import { jsx as o } from "react/jsx-runtime";
import { c as n } from "./index.rKuIKazb.js";
import { Flex as i } from "../flex.js";
import { Text as c } from "../text.js";
import '../assets/field-error.css';const N = (r, t = (e) => e === void 0) => r ? Object.keys(r).reduce((s, a) => (t(r[a]) || (s[a] = r[a]), s), {}) : {}, l = "_caption_hnn6i_3", p = {
  caption: l
}, m = ({
  invalid: r,
  children: t,
  className: e
}) => {
  const s = n(p.caption, e);
  return /* @__PURE__ */ o(
    c,
    {
      className: s,
      variant: "cap-100",
      color: r ? "sig-error" : "c-mid-contrast",
      asChild: !0,
      children: /* @__PURE__ */ o(i, { gap: 100, alignItems: "center", width: "full", children: t })
    }
  );
};
m.displayName = "Field.Caption";
const d = "_error_rhwnt_3", u = {
  error: d
}, h = ({ id: r, children: t, className: e }) => {
  const s = n(u.error, e);
  return /* @__PURE__ */ o(i, { gap: 100, alignItems: "center", asChild: !0, children: /* @__PURE__ */ o(c, { id: r, className: s, variant: "cap-100", color: "sig-error", children: t }) });
};
h.displayName = "FieldError";
export {
  h as F,
  m as a,
  N as s
};
//# sourceMappingURL=field-error.DDRV9OmH.js.map
